/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Work_0_Metric_0_LabelInputs */

const en_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer grounding`)
};

const ar_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استناد الإجابة`)
};

const bn_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উত্তর গ্রাউন্ডিং`)
};

const de_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworterdung`)
};

const es_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta a tierra`)
};

const fr_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse à la mise à la terre`)
};

const pt_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder aterramento`)
};

const zh_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答案接地`)
};

const tr_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cevap temeli`)
};

const ru_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обоснование ответа`)
};

const pl_svc_ai_integration_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uziemienie odpowiedzi`)
};

/**
* | output |
* | --- |
* | "Answer grounding" |
*
* @param {Svc_Ai_Integration_Work_0_Metric_0_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_work_0_metric_0_label = /** @type {((inputs?: Svc_Ai_Integration_Work_0_Metric_0_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Work_0_Metric_0_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "bn") return bn_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "de") return de_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "es") return es_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "fr") return fr_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "pt") return pt_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "zh") return zh_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "tr") return tr_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "ru") return ru_svc_ai_integration_work_0_metric_0_label(inputs)
	if (locale === "pl") return pl_svc_ai_integration_work_0_metric_0_label(inputs)
	return en_svc_ai_integration_work_0_metric_0_label(inputs)
});
export { svc_ai_integration_work_0_metric_0_label as "svc_ai-integration_work_0_metric_0_label" }